// Module
var code = `<img class="{{\$ctrl.classes}}" width="300" height="300" ng-src="{{\$ctrl.url}}"/> `;
// Exports
export default code;